import * as Yup from "yup";

const userValidationSchema = Yup.object().shape({
  customerFirstName: Yup.string()
    .min(2, "First Name must be at least 2 characters")
    .max(20, "First Name must be 20 characters or less")
    .matches(/^[a-zA-Z0-9-'\s]+$/, {
      message:
        "First name must contain only alphanumeric characters and allowed special characters (-, ', and space)",
      excludeEmptyString: true,
    })
    .trim()
    .required("First Name is required"),
  customerLastName: Yup.string()
    .min(2, "Last Name must be at least 2 characters")
    .max(20, "Last Name must be 20 characters or less")
    .matches(/^[a-zA-Z0-9-'\s]+$/, {
      message:
        "Last name must contain only alphanumeric characters and allowed special characters (-, ', and space)",
      excludeEmptyString: true,
    })
    .trim()
    .required("Last Name is required"),
  phoneNumber: Yup.string()
    .min(10, "Must be a valid phone number")
    .max(13, "Must be a valid phone number")
    .matches(/^(?!0+$)(\+44\s?|0)\d{3,4}[-\s]?\d{3}[-\s]?\d{4,6}$/, {
      message: "Must be a valid phone number",
      excludeEmptyString: true,
    })
    .required("Phone Number is required"),
  customerId: Yup.string()
    .min(2, "Reference Number must be at least 2 characters")
    .max(20, "Reference Number must be 20 characters or less")
    .matches(/^\d*$/, {
      message: "Reference Number should only contain numerical characters",
      excludeEmptyString: true,
    })
    .trim()
    .required("Reference Number is required"),
});

export default userValidationSchema;
